import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { values } from 'lodash';

const AdminModalComponent = ({ isOpen, toggle, name, email, userDescription, updateDataRequired }) => {
  const [editedUserDescription, setEditedUserDescription] = useState(userDescription);

  const [modalStyles, setModalStyles] = useState({
    zIndex: '1',
  });


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 992) {
        setModalStyles({
          ...modalStyles,
          width: '100%',
          paddingRight: '18px',
          left : '0'
        });
      } else {
        setModalStyles({
          ...modalStyles,
          width: 'auto',
          left:'50px',
        });
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [modalStyles]);

  return (
    <Modal style={modalStyles} isOpen={isOpen} toggle={toggle} className=' modal-lg'>
      <ModalHeader toggle={toggle}>
        <h4 className='mb-0'>Send Email Notification</h4>
      </ModalHeader>
      <ModalBody>
        <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <h6 className="mb-1 pb-0">Name</h6>
            <TextField
              id="userName"
              variant="outlined"
              className='border border-black rounded-3'
              placeholder="Name"
              value={name}
              disabled
            />

            <h6 className="mt-3 mb-1 pb-0">Email</h6>
            <TextField
              id="userEmail"
              variant="outlined"
              className='border border-black rounded-3'
              type="email"
              placeholder="tahira@gmail.com"
              value={email}
              disabled
            />
            
            <h6 className="mt-3 mb-1 pb-0">Subject</h6>
            <TextField
              id="subject"
              variant="outlined"
              className='border border-black rounded-3'
              type="text"
              placeholder="Type Subject here"

            />

            <h6 className="mt-3 mb-1 pb-0">Message</h6>
            <TextareaAutosize
              id="userDescription"
              className='border border-black rounded-3 p-2'
              minRows={6}
              maxRows={20}
              placeholder="Type your message here"
              value={editedUserDescription}
              onChange={(e) => setEditedUserDescription(e.target.value)}
            />
          </FormControl>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
        <Button className="btnStyling">
          Send Email
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AdminModalComponent;

